import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';

export interface payerParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface payer { 

    payerReceiptMaster:payerReceiptMaster;
    payerReceiptDetail:payerReceiptDetail[];
    payerReceiptBillDetail:payerReceiptBillDetail[];
   
    parameters?: payerParameter[];
    links?: any;
}

export interface payerReceiptMaster { 

    totalAmt:number;
    payerId?:string;
    createdBy:string;
    tenantId: string;
    branchId: string;

    parameters?: payerParameter[];
    links?: any;
}

export interface payerReceiptDetail { 

    paymentMode:string;
    cash:number;
    creditCard:number;
    cheque:number;
    upiPayment:number;
    neft:number;
    transactionNo: string;
    tenantId: string;
    branchId: string;

    parameters?: payerParameter[];
    links?: any;
}

export interface payerReceiptBillDetail { 

    PatType:string;
    RegId:string;
    BillId?:number;
    IPID?:number;
    AmtClaimed:number;
    DisallowedAmt:number;
    HospitalDiscount:number;
    TDSAmt:number;
    TotalWithDeduction:number;
    AmtSettled:number;
    Roundoff:number;
    Amount:number;
    creditstatus:string;
    CreatedBy:string;
    tenantId: string;
    branchId: string;

    parameters?: payerParameter[];
    links?: any;
}


export abstract class payerData {
    abstract list(url: string): Observable<any>; 
    abstract getById(url: string): Observable<any>;
    abstract searchList(url: string,data:any): Observable<any>;
    abstract getall(url: string): Observable<payer[]>;
    abstract create(url: string, data: any): Observable<payer[]>;
    abstract getData(url: string, data: any): Observable<any[]>;
    abstract update(url: string, data: any): Observable<payer>;
}
